import React, {useCallback, useEffect, useState} from 'react';
import {BodyAreaList} from "../../../../components/admin/equipment/BodyAreaList";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {bodyAreaResultCollectionType, bodyAreaResultType} from "../../../../types/Api/BodyAreaResultType";
import {bodyAreaHydrator} from "../../../../models/hydrator/bodyAreaHydrator";
import {bodyArea} from "../../../../models/bodyArea";
import {Pagination} from "../../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Tab} from "../../../../components/admin/equipment/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bodyAreas, setBodyAreas] = useState([] as bodyArea[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findBodyArea = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'label',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<bodyAreaResultCollectionType> = ApiService.get('/body-area', apiFilters) as Promise<bodyAreaResultCollectionType>;

    result
      .then((r: bodyAreaResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setBodyAreas(r._embedded['body-areas'].map((bodyArea: bodyAreaResultType) => {
          return bodyAreaHydrator.hydrate(bodyArea);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setBodyAreas([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findBodyArea();
  }, [findBodyArea]);

  return (
    <>
      <BoxTitle title="Gestion de la zone du corps"/>
      <Tab/>
      <BodyAreaList bodyAreas={bodyAreas} loading={loading} refresh={findBodyArea}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 d-flex justify-content-between">
        <NavLink to={`/admin/equipment/body-area/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter une zone
        </NavLink>
      </div>
    </>
  )
}